angular.module('logbook')
  .controller('reminder-detail', ['$scope', '$http', '$location', '$window', '$filter', '$timeout', '$sce', '$q', 'reminderService', 'tagDetector', 'errorHandler',
      function($scope, $http, $location, $window, $filter, $timeout, $sce, $q, reminderService, tagDetector, errorHandler) {
		let statusPromise = reminderService.getStatuses().toPromise().then(function(statuses) {
			$scope.reminderStatuses = statuses;

			for (var i = 0, status; status = $scope.reminderStatuses[i]; i++) {
				if( status.name == 'D')
				   $scope.deletedStatus = status._links.self.href;
				else if( status.name == 'P')
				   $scope.pendingStatus = status._links.self.href;
			 }
		})
        
        $scope.$sce = $sce;
        $scope.fileAttachments = [];
        $scope.isUploading = false;
        $scope.isNew = !$location.search()['query'] && !$location.search()['reminder'];
        $scope.isPreview = !$scope.isNew;
        $scope.previewRecurrence = [];
        $scope.detectedTagValues = [];
        $scope.newTagValues = [];
        $scope.selectedTagValueObjects = [];
        $scope.editTagValues = [];
        
        if( $scope.isNew )
        {
           $timeout(function() {
              $scope.reminderTypeForm.$show();
              $scope.editingStartTime = true;
              $scope.editingEndTime = true;
              $scope.reminderStatusForm.$show();
              $scope.reminderTextForm.$show();
              
              statusPromise.then(() => {
                  $scope.reminder.status = $scope.newStatus = $scope.pendingStatus;
              })
           });
        }

        $scope.reminder = {
              "status" : $scope.pendingStatus,
              "log" : $scope.selectedLog._links.self.href,
              "request": '',
              "newAttachments" : [],
              "removeAttachments" : [],
              "recurrenceSpec" : {},
              "tagValues": []
              };
        
        $scope.types = [
           {id: 'S', label:'Simple'},
           {id: 'SS', label: 'Start / Stop'}
        ];
        

        $scope.setType = function($data)
        {
           $scope.isSimple = 'S' === $data.id;
        }
        
        $scope.setNewStatus = function($data)
        {
           $scope.newStatus = $data;
        }
        
        $scope.reminderType = $scope.types[0];
        $scope.setType($scope.reminderType);

        
        $scope.$watch('selectedLog', function() {
           if( $scope.isNew && $scope.selectedLog)
           {
              $scope.reminder.log = $scope.selectedLog._links.self.href;
              $scope.reminder.tagValues = [];
           }
              
        });
        
        $scope.refreshReminder = function(href)
        {
           $http.get(href, {
              params: {
                 'projection': 'reminderProjection'
              }
           }).then(function(result) {
               $scope.populateFields(result.data);
           });
        };
        
        if( $location.search()['reminder'] )
        {
           $scope.refreshReminder($location.search()['reminder']);
        }
        

        $scope.populateFields = function(reminder)
        {
           $scope.isNew = false;
           $scope.reminder = reminder;
           $scope.reminder.recurrenceSpec = {};
           $scope.reminder.newAttachments = [];
           $scope.reminder.removeAttachments = [];
           
           if( $scope.reminder.logId !== $scope.selectedLog.id )
           {
              $scope.reminderSaved();
           }

           
           $scope.startTime = new Date($scope.reminder.startTime.replace(/\+0000/,'Z'));
           $scope.newStartTime = new Date($scope.startTime);
           
           $scope.endTime = new Date($scope.reminder.endTime.replace(/\+0000/,'Z'));
           $scope.newEndTime = new Date($scope.endTime);
           
           $scope.reminderType = $scope.types[$scope.startTime.getTime() == $scope.endTime.getTime() ? 0 : 1];
           $scope.setType($scope.reminderType);
           
           $scope.reminder.statusUrl = $scope.reminder.status._links.self.href.replace(/\{.*\}/,'');
           $scope.newStatus = $scope.reminder.statusUrl;
           
           $scope.newReminderText = $scope.reminder.request;
           $scope.previewReminder = $scope.reminder.safeHtmlRequest;
           
           $scope.reminder.attachments &&
              $scope.reminder.attachments.forEach(function(attachment) {
                 $scope.fileAttachments.push(attachment);
              });
           
           $scope.reminder.tagValueUrls = [];
           $scope.editTagValues = [];
           $scope.selectedTagValueObjects = [];
           $scope.reminder.tagValues &&
              $scope.reminder.tagValues.forEach(function(tagValue) {
                 tagValue._links.self.href = tagValue._links.self.href.replace(/\{.*\}/,'')
                 $scope.editTagValues.push(tagValue._links.self.href);
                 $scope.selectedTagValueObjects.push(tagValue);
              });
           $scope.populated = true;
           
        };

        $scope.backToList = function()
        {
           console.log('log='+$location.search()['log']);
           $scope.query.size=10000;
           $scope.query.page=0;
           var queryFormat = $location.search()['query-format'];
           var resultFormat = $location.search()['result-format'];
           $location.url('/reminder-query')
              .search('query', JSON.stringify($scope.query))
              .search('result-format', resultFormat)
              .search('query-format', queryFormat);
        }
        
        $scope.filterStatus = function(status)
        {
           var retval = 
              ($scope.isSimple && status.name != 'E' && status.name != 'A')
              ||
              (!$scope.isSimple && status.name != 'K');
           
           retval = retval && (!$scope.isNew || status.name != 'D');
           
           return retval;
        };
        
        $scope.save = function() {
            if (!$scope.reminder.request)
            {
                window.alert('The reminder body must not be blank.');
                return;
            }
           if( $scope.isUploading )
           {
              window.alert("Please wait for the file upload(s) to complete.");
              return;
           }
           
           if( $scope.reminder.statusUrl == $scope.deletedStatus 
               && !$scope.confirmDelete )
              throw new Error('Must confirm deletion before submitting.');
           
           if( $scope.reminder.statusUrl == $scope.deletedStatus
               && !$scope.reminder.updateFutureRecurrenceMembers)
           {
              $http.delete($scope.reminder._links.self.href).then(function() {
                 $scope.reminderSaved();
              });
              return;
           }
           
           try {
               $scope.reminder.startTime = new Date($scope.newStartTime).toISOString();
           }
           catch (e)
           {
               errorHandler.handle(e.message, $scope.newStartTime || 'newStartTime was invalid', false);
               return displayFailedTimeError('start');
           }
           
           if( $scope.isSimple )
              $scope.reminder.endTime = $scope.reminder.startTime;
           else {
               try {
                   $scope.reminder.endTime = new Date($scope.newEndTime).toISOString();
               }
               catch (e) {
                   errorHandler.handle(e.message, $scope.newEndTime || 'newEndTime was invalid', false);
                   return displayFailedTimeError('end');
               }
           }
           
           if( $scope.reminder.recurrenceSpec 
               && $scope.reminder.recurrenceSpec.unit
               && $scope.previewRecurrence.length == 0)
           {
           
              $scope.reminder.recurrenceSpec.firstBeginTime = $scope.reminder.startTime;
              $scope.reminder.recurrenceSpec.firstEndTime = $scope.reminder.endTime;
              $http.post('/api/previewRecurringReminders',$scope.reminder.recurrenceSpec)
                 .then(function(results)
                    {
                       $scope.previewRecurrence = results.data;
                       $scope.noRecurrences = !results.data.length;
                    });
           }
           else
           {
              tagDetector.createNewTagValues(
                 $scope.newTagValues,
                 $scope.editTagValues,
                 $scope.selectedTagValueObjects,
                 $scope.selectedLog)
                 .then(function() {
                    if( $scope.isNew )
                    {
                       if( $scope.reminder.recurrenceSpec && !$scope.reminder.recurrenceSpec.unit )
                          delete $scope.reminder.recurrenceSpec;
                       $scope.reminder.tagValues = $scope.editTagValues;
                       $http.post('/api/reminders',$scope.reminder).then($scope.reminderSaved)
                    }
                    else
                    {
                       if( $scope.reminder.recurrenceSpec && !$scope.reminder.recurrenceSpec.unit )
                          delete $scope.reminder.recurrenceSpec;
                       $http.put($scope.reminder._links.self.href, $scope.reminder).then($scope.reminderSaved);
                    }
                 });
           }
        };
        
        $scope.reminderSaved = function() {
           if( $scope.query )
              $scope.backToList();
           else
              $timeout(function() {
                 $window.history.back();
              });
              
        }
        
        $scope.reminderChanged = function($data) {
           if( $scope.isNew )
              $scope.reminder.request = $data;
           $scope.newReminderText = $data;
           
           var canCreateTag = !$scope.selectedLog.adminRequiredForTagEdit
              || $scope.selectedLog.role == 'ADMIN';
        
           tagDetector.detectTags(
                 $scope.selectedLog,
                 $data,
                 $scope.detectedTagValues,
                 canCreateTag ? $scope.newTagValues : null,
                 $scope.editTagValues,
                 $scope.selectedTagValueObjects);
        };
        
        $scope.toggleView = function()
        {
           $scope.isPreview = !$scope.isPreview;
           if( !$scope.isPreview && !$scope.isNew )
           {
              $scope.reminderTextForm.$show();
           }
           if( $scope.isPreview )
           {
                 $http.post('/api/markdown', {
                    'markdown': $scope.newReminderText
                 }).then(function(result) {
                    $scope.previewReminder = result.data.html;
                 });
           }

        };

        $scope.viewRecurrenceQuery = function() {
           var query = {
              recurrence: $scope.reminder.recurrence.id,
              fromDate: null,
              thruDate: null,
              sort: ['startTime,asc','updated,desc']
           };
           $location.url('/reminder-query')
              .search('query', JSON.stringify(query))
              .search('query-format', 'A')
              .search('result-format', 'D');
        };
        
        $scope.updateReminder= function(reminder, data)
        {
            if (!data)
            {
                window.alert('The reminder body must not be blank.');
                return $q.reject();
            }
           return tagDetector.createNewTagValues(
                 $scope.newTagValues,
                 $scope.editTagValues,
                 $scope.selectedTagValueObjects,
                 $scope.selectedLog
              ).then(function() {
                 
                 var update = {};
                 update['request'] = data;
                 update['tagValues'] = $scope.editTagValues;
                 if( $scope.reminder.updateFutureRecurrenceMembers )
                    update['updateFutureRecurrenceMembers'] = true;
                 return $http.patch(reminder._links.self.href, update).then(function() {
                    $http.get(reminder._links.self.href, {
                       params: {
                          'projection': 'reminderProjection'
                       }
                    }).then(function(result) {
                       $scope.isPreview = true;
                       $scope.newTagValues.length = 0;
                       $scope.refreshReminder(result.data._links.self.href);
                    });
                 });
              });
        };
        
        $scope.clearReminderStatusError = function()
        {
           delete $scope.reminderStatusError;
                      
        }
        $scope.updateReminderField = function(reminder, field, data)
        {
           $scope.clearReminderStatusError();
           var update = {};
           update[field] = data;
           if( $scope.reminder.updateFutureRecurrenceMembers )
              update['updateFutureRecurrenceMembers'] = true;
           if( $scope.isSimple && field == 'startTime' )
              update['endTime'] = data;
           if( field == 'status' 
                && data == $scope.deletedStatus 
                && !$scope.reminder.updateFutureRecurrenceMembers)
           {
              if( !$scope.confirmDelete )
              {
                 var d = $q.defer();
                 d.reject();
                 $scope.reminderStatusError = 'Confirmation box must be checked.';
                 return d.promise;
              }
              return $http.delete(reminder._links.self.href).then($scope.reminderSaved);
           }
           
           return $http.patch(reminder._links.self.href, update).then(function(result) {
              if( field != 'removeAttachments' && field != 'newAttachments')
                 reminder[field]=data;
              
              if( field == 'status')
                 if( $scope.reminder.updateFutureRecurrenceMembers && data == $scope.deletedStatus )
                    $scope.reminderSaved();
                 else
                    $scope.reminder.status
                       = result.data._embedded.status;
           });
        };
        
        function displayFailedTimeError(field)
        {
            window.alert('The ' + field + ' time is invalid.');
            return $q.reject();
        }

        $scope.updateStartTime = function(reminder, time)
        {
            if (!time)
                return displayFailedTimeError('start');
            
           return $scope.updateReminderField(reminder, 'startTime', time).then(function() {
              $scope.startTime = new Date(time);
              $scope.newStartTime = new Date($scope.startTime);
              $scope.editingStartTime = false;
           });
        };
        
        $scope.updateEndTime = function(reminder, time)
        {
            if (!time)
                return displayFailedTimeError('end');
            
           return $scope.updateReminderField(reminder, 'endTime', time).then(function() {
              $scope.endTime = new Date(time);
              $scope.newEndTime = new Date($scope.endTime);
              $scope.editingEndTime = false;
           });
        };
        
        $scope.doneEditingTags = function()
        {
           $scope.editingTags=false;
        };

        
        if( !$scope.isNew )
        {
           $scope.$watch('reminder.newAttachments', function(data) {
              if( $scope.newAttachmentUploadHandle )
                 $timeout.cancel($scope.newAttachmentUploadHandle);
              $scope.newAttachmentUploadHandle = $timeout(function() {
                 if( data && data.length )
                 {
                    var files = data.slice(0);
                    files.forEach(function(file) {
                       $scope.reminder.newAttachments.splice($scope.reminder.newAttachments.indexOf(file), 1);
                    });
                    $scope.updateReminderField($scope.reminder, 'newAttachments', files).then(function() {
                    });
                 }
              }, 250);
           }, true);
        
           $scope.$watch('reminder.removeAttachments', function(data) {
              if( data && data.length )
              {
                 var files = data.slice(0);
                 files.forEach(function(file) {
                    $scope.reminder.removeAttachments.splice($scope.reminder.removeAttachments.indexOf(file), 1);
                 $scope.updateReminderField($scope.reminder, 'removeAttachments', files).then(function() {
                    files.forEach(function(file) {
                       $scope.fileAttachments.forEach(function(att) {
                          if( att.id == file )
                             $scope.fileAttachments.splice($scope.fileAttachments.indexOf(att), 1);
                       });
                       $scope.reminder.attachments
                       && $scope.reminder.attachments.forEach(function(att) {
                          if( att.id == file )
                             $scope.reminder.attachments.splice($scope.reminder.attachments.indexOf(att), 1);
                       });
   
                    });
                    });
                 });
              }
           }, true);
        }
  }]);